import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 22l-5 -5","key":"svg-0"}],["path",{"d":"M17 22l5 -5","key":"svg-1"}],["path",{"d":"M13 21h-7a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v9","key":"svg-2"}],["path",{"d":"M9 18h4","key":"svg-3"}]]

const IconDeviceIpadX = createReactComponent('outline', 'device-ipad-x', 'DeviceIpadX', __iconNode);

export default IconDeviceIpadX;